import React from 'react';
import BaseSkeleton from '../../components/common/skeleton';

export default function Skeleton() {
  return (
    <div className="dashboard-data-space-view-providerlinks">
      <BaseSkeleton count={5} height={20} className="resources-skeleton" />
    </div>
  );
}
